import {
  isString,
  registerDecorator,
  ValidationOptions,
} from 'class-validator';

/**
 * Validates a Swedish mobile number
 * @reference https://sv.wikipedia.org/wiki/Lista_%C3%B6ver_svenska_riktnummer#Prefixnummer
 * @param value string - mobile number
 * @returns boolean
 * @source https://sv.wikipedia.org/wiki/Riktnummer
 */
export const mobileRegex = /^07[02369]-?\d{7}$/;
export function isMobile(value: string) {
  return mobileRegex.test(value);
}

type MobileValidationOptions = ValidationOptions & {
  loose?: boolean;
};

/**
 * Validates that the value is a valid Swedish mobile number
 * @param validationOptions - class-validator ValidationOptions
 * @param validationOptions.loose - boolean - allow any 10 digit number starting with 0
 * @returns
 * @source https://sv.wikipedia.org/wiki/Riktnummer
 */
export function IsMobile(validationOptions: MobileValidationOptions = {}) {
  return function (object: object, propertyName: string) {
    registerDecorator({
      name: 'isMobile',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate(value: unknown) {
          if (!isString(value)) return false;

          const filtered = value.replace(/-/g, '');
          if (/^\D+$/.test(filtered)) return false;
          if (!filtered.startsWith('0')) return false;
          if (filtered.length !== 10) return false;
          if (validationOptions?.loose) return true;
          return isMobile(value);
        },
        defaultMessage(validationArguments) {
          const value = validationArguments?.value;
          if (!isString(value)) return 'INVALID_MOBILE';

          const filtered = value.replace(/-/g, '');
          if (/^\D+$/.test(value)) return 'INVALID_MOBILE';
          if (filtered.length < 10) return 'TOO_SHORT_MOBILE';
          if (filtered.length > 10) return 'TOO_LONG_MOBILE';
          return 'INVALID_MOBILE';
        },
      },
    });
  };
}
